import React from 'react';
import './styles.scss';

interface ScheduleItem {
  date: string;
  description: string;
}

const EndYearSchedule: React.FC = () => {
  // Verifica se a data atual é menor que 03/01/2025
  const checkDate = (): boolean => {
    const currentDate = new Date();
    const limitDate = new Date('2026-01-03');
    return currentDate < limitDate;
  };

  const scheduleData: ScheduleItem[] = [
    { date: '22 e 23/12', description: 'Expediente Normal' },
    { date: '29 e 30/12', description: 'Expediente Normal' },
    { date: '24/12 - Recesso', description: 'Plantão: 09:00 às 12:00' },
    { date: '31/12 - Recesso', description: 'Plantão: 09:00 às 12:00' },
    { date: '25/12', description: '🎅 Feriado de Natal' },
    { date: '01/01', description: '🎆 Feriado de Ano Novo' },
    { date: '26/12 - Recesso', description: 'Plantão: 13:30 às 18:00' },
    { date: '02/01 - Recesso', description: 'Plantão: 13:30 às 18:00' },
  ];

  if (!checkDate()) {
    return null;
  }

  return (
    <div className="end-year-schedule">
      <h2 className="schedule-title">🎄 Horários de Fim de Ano</h2>
      <div className="schedule-grid">
        {scheduleData.map((item, index) => (
          <div key={index} className="schedule-card">
            <div className="schedule-date">{item.date}</div>
            <div className="schedule-description">{item.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EndYearSchedule;
